// extracted by mini-css-extract-plugin
export default {"main":"range_main__JP2qH"};